module.exports = __webpack_public_path__ + "img/icon_category_02_w.bb812ae3.svg";